import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, HostBinding, Inject, NgModule } from '@angular/core';
import * as i2 from '@ngrx/store';
import { LoadLeagueResultsOnceAction, getLeagueResults, entryAvailable, LoadMatchResultReportOnceAction, LoadMatchDateReportOnceAction, getMatchDateReport, exists, getMatchResultReport, distinct, LoadMatchChallengeReportOnceAction, getMatchChallengeReport, getUser, LoadLeagueCompleteAction, LoadContestantsOnceAction, getContestants, getLeague, createLoadingEntryState, LoadTeamOnceAction, getTeam } from '@play/state';
import * as i3$2 from '@play/api-client';
import { filter, map, shareReplay, switchMap, tap, startWith, withLatestFrom } from 'rxjs/operators';
import { of, combineLatest } from 'rxjs';
import * as i1 from '@play/common';
import { BASE_CONFIG, CommonsComponentModule, CommonsLocationModule, CommonsErrorModule } from '@play/common';
import { isLadder, getStartDate, isInProgress, isFinished, getCheckInTimeline, getLateSignUpTimeline, isInSignUp, isInCheckIn, isInLateSignUp, isTeam, isFFA, isLongRunning, isEnterResultEnabled } from '@play/utility/league';
import { isClosed, isOpen, isException, isChallenge, isProtest } from '@play/utility/match';
import { compose, prop, complement, sortWith, ascend, sortBy, anyPass } from 'ramda';
import { getName, getId as getId$1 } from '@play/utility/team';
import * as momentImported from 'moment';
import { getName as getName$1, getActualContestant, isTeam as isTeam$1, getId } from '@play/utility/contestant';
import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3$1 from '@play/league';
import { LeagueModule } from '@play/league';
import { ContestantStates, MatchStates } from '@play/api-typings';
import * as i3 from '@play/translate';
import { TranslationModule } from '@play/translate';

const moment = momentImported;
const stringToTimestamp = (date) => moment(date).unix();
const getMatchTimestamp = compose(stringToTimestamp, prop("beginAt"));
const leagueTypeSort = (league) => {
    if (isLadder(league.league.entry) && league.matches.entry) {
        return league.matches.entry.filter(complement(isClosed)).length ? 1 : 2;
    }
    return 1;
};
const leagueDateSort = (league) => {
    const matches = league.matches.entry ? league.matches.entry.filter(complement(isClosed)) : [];
    if (isLadder(league.league.entry) && !matches.length) {
        return league.league.entry.name.full;
    }
    return matches.length
        ? matches.reduce((prev, curr) => Math.min(prev, getMatchTimestamp(curr)), getMatchTimestamp(matches[0]))
        : getStartDate(league.league.entry)
            ? stringToTimestamp(getStartDate(league.league.entry))
            : 0;
};
const leagueNameSort = (a, b) => {
    if (getStartDate(a.league.entry) === getStartDate(b.league.entry)) {
        if (a.league.entry.name && b.league.entry.name) {
            if (a.league.entry.name.full < b.league.entry.name.full) {
                return -1;
            }
            if (a.league.entry.name.full > b.league.entry.name.full) {
                return 1;
            }
        }
    }
    return 0;
};
const leagueSort = sortWith([
    ascend(leagueTypeSort),
    ascend(leagueDateSort),
    leagueNameSort,
]);
const teamNameSort = (a, b) => {
    return getName(a.team).localeCompare(getName(b.team));
};
const matchSort = sortBy(getMatchTimestamp);
const contestantSort = sortWith([teamNameSort]);

class TournamentTeamLinkComponent {
    constructor(links) {
        this.links = links;
    }
    ngOnChanges() {
        this.teamLink = this.links.team(+this.team.id);
    }
}
TournamentTeamLinkComponent.ɵfac = function TournamentTeamLinkComponent_Factory(t) { return new (t || TournamentTeamLinkComponent)(i0.ɵɵdirectiveInject(i1.LinkService)); };
TournamentTeamLinkComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TournamentTeamLinkComponent, selectors: [["user-tournament-team-link"]], inputs: { team: "team" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 8, consts: [[1, "c-user-tournament-team-link", 3, "title", "locationHref"], [1, "c-user-tournament-team-link__icon", 3, "icon"]], template: function TournamentTeamLinkComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "a", 0);
        i0.ɵɵelement(1, "svg-icon", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("title", ctx.team.name)("locationHref", ctx.teamLink);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("width", 16, "px")("height", 16, "px");
        i0.ɵɵproperty("icon", "group");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.team.name, "\n");
    } }, directives: [i1.LocationDirective, i1.SvgIconComponent], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TournamentTeamLinkComponent, [{
        type: Component,
        args: [{
                selector: "user-tournament-team-link",
                templateUrl: "./tournament-team-link.component.html",
                styleUrls: ["./tournament-team-link.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.LinkService }]; }, { team: [{
            type: Input
        }] }); })();

function TournamentNoMatchesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "user-tournament-team-link", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("team", ctx_r0.team);
} }
function TournamentNoMatchesComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-tournament-no-matches:match-waiting"), " ");
} }
function TournamentNoMatchesComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-tournament-no-matches:waiting-for-tournament-start"), " ");
} }
function TournamentNoMatchesComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-tournament-no-matches:sign-up-pending"), " ");
} }
const _c0$7 = function (a0) { return { place: a0 }; };
function TournamentNoMatchesComponent_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "league-interaction:you-finished-nth", i0.ɵɵpureFunction1(4, _c0$7, ctx_r8.contestant.rank.label)), " ");
} }
function TournamentNoMatchesComponent_div_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-tournament-no-matches:you-have-finished"), " ");
} }
function TournamentNoMatchesComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, TournamentNoMatchesComponent_div_5_ng_container_1_Template, 3, 6, "ng-container", 8);
    i0.ɵɵtemplate(2, TournamentNoMatchesComponent_div_5_ng_container_2_Template, 3, 3, "ng-container", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.contestant.rank);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.contestant.rank);
} }
function TournamentNoMatchesComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-tournament-no-matches:waiting-for-checkin"), " ");
} }
function TournamentNoMatchesComponent_a_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("locationHref", ctx_r6.leagueLink);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "user-tournament-no-matches:checkin-is-open"), " ");
} }
function TournamentNoMatchesComponent_empty_call_action_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "empty-call-action", 10);
    i0.ɵɵlistener("action", function TournamentNoMatchesComponent_empty_call_action_8_Template_empty_call_action_action_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.action.emit(); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("actionLabel", i0.ɵɵpipeBind1(1, 2, "user-tournament-no-matches:challenge-someone"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "user-tournament-no-matches:no-upcoming-matches"), " ");
} }
class TournamentNoMatchesComponent {
    constructor(links) {
        this.links = links;
        this.action = new EventEmitter();
    }
    ngOnChanges() {
        this.leagueLink = this.links.league(this.league.id, this.league.uri);
        if (this.contestant) {
            if (!anyPass([isInProgress, isFinished])(this.league) &&
                (this.contestant.state === ContestantStates.CheckedIn ||
                    (this.contestant.state === ContestantStates.SignedUp &&
                        !getCheckInTimeline(this.league.timeline) &&
                        !getLateSignUpTimeline(this.league.timeline)))) {
                this.waitingForTournamentStart = true;
            }
            else {
                this.waitingForTournamentStart = false;
                this.waitingForCheckIn = isInSignUp(this.league) && this.contestant.state === ContestantStates.SignedUp;
                this.checkInIsOpen = isInCheckIn(this.league) && this.contestant.state === ContestantStates.SignedUp;
                this.isInLateSignUpState = isInLateSignUp(this.league) && this.contestant.state === ContestantStates.SignedUp;
                this.signUpPending = this.contestant.state === ContestantStates.SignUpPending;
            }
        }
        else {
            this.waitingForCheckIn = false;
            this.checkInIsOpen = false;
            this.signUpPending = false;
            this.waitingForTournamentStart = false;
        }
    }
}
TournamentNoMatchesComponent.ɵfac = function TournamentNoMatchesComponent_Factory(t) { return new (t || TournamentNoMatchesComponent)(i0.ɵɵdirectiveInject(i1.LinkService)); };
TournamentNoMatchesComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TournamentNoMatchesComponent, selectors: [["user-tournament-no-matches"]], inputs: { isLongRunning: "isLongRunning", isTeamLeague: "isTeamLeague", isEliminated: "isEliminated", team: "team", league: "league", contestant: "contestant" }, outputs: { action: "action" }, features: [i0.ɵɵNgOnChangesFeature], decls: 9, vars: 8, consts: [[1, "c-user-tournament-no-matches"], ["class", "c-user-tournament-no-matches__team", 4, "ngIf"], ["class", "c-user-tournament-no-matches__match-waiting", 4, "ngIf"], ["class", "c-user-tournament-no-matches__match-waiting", 3, "locationHref", 4, "ngIf"], [3, "actionLabel", "action", 4, "ngIf"], [1, "c-user-tournament-no-matches__team"], [3, "team"], [1, "c-user-tournament-no-matches__match-waiting"], [4, "ngIf"], [1, "c-user-tournament-no-matches__match-waiting", 3, "locationHref"], [3, "actionLabel", "action"]], template: function TournamentNoMatchesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, TournamentNoMatchesComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵtemplate(2, TournamentNoMatchesComponent_div_2_Template, 3, 3, "div", 2);
        i0.ɵɵtemplate(3, TournamentNoMatchesComponent_div_3_Template, 3, 3, "div", 2);
        i0.ɵɵtemplate(4, TournamentNoMatchesComponent_div_4_Template, 3, 3, "div", 2);
        i0.ɵɵtemplate(5, TournamentNoMatchesComponent_div_5_Template, 3, 2, "div", 2);
        i0.ɵɵtemplate(6, TournamentNoMatchesComponent_div_6_Template, 3, 3, "div", 2);
        i0.ɵɵtemplate(7, TournamentNoMatchesComponent_a_7_Template, 3, 4, "a", 3);
        i0.ɵɵtemplate(8, TournamentNoMatchesComponent_empty_call_action_8_Template, 4, 6, "empty-call-action", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isTeamLeague && ctx.team);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isLongRunning && !ctx.waitingForCheckIn && !ctx.checkInIsOpen && !ctx.isEliminated && !ctx.signUpPending && !ctx.waitingForTournamentStart && !ctx.isInLateSignUpState);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.waitingForTournamentStart);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.signUpPending);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isEliminated);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.waitingForCheckIn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.checkInIsOpen || ctx.isInLateSignUpState);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isLongRunning);
    } }, directives: [i6.NgIf, TournamentTeamLinkComponent, i1.LocationDirective, i1.EmptyCallActionComponent], pipes: [i3.TranslatePipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TournamentNoMatchesComponent, [{
        type: Component,
        args: [{
                selector: "user-tournament-no-matches",
                templateUrl: "./tournament-no-matches.component.html",
                styleUrls: ["./tournament-no-matches.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.LinkService }]; }, { isLongRunning: [{
            type: Input
        }], isTeamLeague: [{
            type: Input
        }], isEliminated: [{
            type: Input
        }], team: [{
            type: Input
        }], league: [{
            type: Input
        }], contestant: [{
            type: Input
        }], action: [{
            type: Output
        }] }); })();

const _c0$6 = ["user-match-label", ""];
const _c1$6 = ["*"];
class UserMatchLabelComponent {
    get useClass() {
        return true;
    }
    get showPrimary() {
        return this.matchState === MatchStates.Open;
    }
    get showWarning() {
        return this.matchState === MatchStates.Challenge || this.matchState === MatchStates.Exception;
    }
    get showFailure() {
        return this.matchState === MatchStates.Protest;
    }
}
UserMatchLabelComponent.ɵfac = function UserMatchLabelComponent_Factory(t) { return new (t || UserMatchLabelComponent)(); };
UserMatchLabelComponent.ɵcmp = i0.ɵɵdefineComponent({ type: UserMatchLabelComponent, selectors: [["", "user-match-label", ""]], hostVars: 10, hostBindings: function UserMatchLabelComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("c-user-match-label", ctx.useClass)("c-label", ctx.useClass)("c-label--primary", ctx.showPrimary)("c-label--warning", ctx.showWarning)("c-label--failure", ctx.showFailure);
    } }, inputs: { matchState: "matchState" }, attrs: _c0$6, ngContentSelectors: _c1$6, decls: 1, vars: 0, template: function UserMatchLabelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserMatchLabelComponent, [{
        type: Component,
        args: [{
                selector: "[user-match-label]",
                templateUrl: "./match-label.component.html",
                styleUrls: ["./match-label.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { matchState: [{
            type: Input
        }], useClass: [{
            type: HostBinding,
            args: ["class.c-user-match-label"]
        }, {
            type: HostBinding,
            args: ["class.c-label"]
        }], showPrimary: [{
            type: HostBinding,
            args: ["class.c-label--primary"]
        }], showWarning: [{
            type: HostBinding,
            args: ["class.c-label--warning"]
        }], showFailure: [{
            type: HostBinding,
            args: ["class.c-label--failure"]
        }] }); })();

const _c0$5 = ["user-match-date", ""];
const _c1$5 = ["*"];
class MatchDateComponent {
    constructor() { }
    get useClass() {
        return true;
    }
}
MatchDateComponent.ɵfac = function MatchDateComponent_Factory(t) { return new (t || MatchDateComponent)(); };
MatchDateComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchDateComponent, selectors: [["", "user-match-date", ""]], hostVars: 2, hostBindings: function MatchDateComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("c-user-match-date", ctx.useClass);
    } }, attrs: _c0$5, ngContentSelectors: _c1$5, decls: 1, vars: 0, template: function MatchDateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchDateComponent, [{
        type: Component,
        args: [{
                selector: "[user-match-date]",
                templateUrl: "./match-date.component.html",
                styleUrls: ["./match-date.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return []; }, { useClass: [{
            type: HostBinding,
            args: ["class.c-user-match-date"]
        }] }); })();

const _c0$4 = ["user-match-name", ""];
const _c1$4 = ["*"];
class MatchNameComponent {
    constructor() { }
    get useClass() {
        return true;
    }
}
MatchNameComponent.ɵfac = function MatchNameComponent_Factory(t) { return new (t || MatchNameComponent)(); };
MatchNameComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchNameComponent, selectors: [["", "user-match-name", ""]], hostVars: 2, hostBindings: function MatchNameComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("c-user-match-name", ctx.useClass);
    } }, attrs: _c0$4, ngContentSelectors: _c1$4, decls: 1, vars: 0, template: function MatchNameComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchNameComponent, [{
        type: Component,
        args: [{
                selector: "[user-match-name]",
                templateUrl: "./match-name.component.html",
                styleUrls: ["./match-name.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return []; }, { useClass: [{
            type: HostBinding,
            args: ["class.c-user-match-name"]
        }] }); })();

const _c0$3 = ["user-match-action", ""];
const _c1$3 = ["*"];
class MatchActionComponent {
    get useClass() {
        return true;
    }
}
MatchActionComponent.ɵfac = function MatchActionComponent_Factory(t) { return new (t || MatchActionComponent)(); };
MatchActionComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchActionComponent, selectors: [["", "user-match-action", ""]], hostVars: 2, hostBindings: function MatchActionComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("c-user-match-action", ctx.useClass);
    } }, attrs: _c0$3, ngContentSelectors: _c1$3, decls: 1, vars: 0, template: function MatchActionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchActionComponent, [{
        type: Component,
        args: [{
                selector: "[user-match-action]",
                templateUrl: "./match-action.component.html",
                styleUrls: ["./match-action.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { useClass: [{
            type: HostBinding,
            args: ["class.c-user-match-action"]
        }] }); })();

const _c0$2 = function (a0) { return { "c-user-tournament-match-list-item__waiting": a0 }; };
function TournamentMatchListItemComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "a", 8);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "span", 9);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, " vs. ");
    i0.ɵɵelementStart(8, "span", 9);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("locationHref", ctx_r0.matchLink)("title", (ctx_r0.contestantNames[0] || i0.ɵɵpipeBind1(2, 6, "user-tournament-match-list-item:tbd")) + " vs. " + (ctx_r0.contestantNames[1] || i0.ɵɵpipeBind1(3, 8, "user-tournament-match-list-item:tbd")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c0$2, !ctx_r0.contestantNames[0]));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.contestantNames[0] || i0.ɵɵpipeBind1(6, 10, "user-tournament-match-list-item:tbd"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c0$2, !ctx_r0.contestantNames[1]));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.contestantNames[1] || i0.ɵɵpipeBind1(10, 12, "user-tournament-match-list-item:tbd"), " ");
} }
function TournamentMatchListItemComponent_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-tournament-match-list-item:waiting-for-result"), " ");
} }
const _c1$2 = function (a0) { return { number: a0 }; };
const _c2 = function (a0) { return { round: a0 }; };
const _c3 = function (a0) { return { group: a0 }; };
function TournamentMatchListItemComponent_ng_container_6_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "small", 14);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, " \u2013 ");
    i0.ɵɵelementStart(8, "small", 14);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const matchResult_r7 = ctx.ngIf;
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("locationHref", ctx_r6.matchLink);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 4, "ffa-match:match-number", i0.ɵɵpureFunction1(13, _c1$2, matchResult_r7.position)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(6, 7, "ffa-match:round", i0.ɵɵpureFunction1(15, _c2, matchResult_r7.round)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(10, 10, "ffa-match:group", i0.ɵɵpureFunction1(17, _c3, matchResult_r7.group + 1)));
} }
function TournamentMatchListItemComponent_ng_container_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, TournamentMatchListItemComponent_ng_container_6_div_2_ng_container_1_Template, 11, 19, "ng-container", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r4.matchResult$));
} }
function TournamentMatchListItemComponent_ng_container_6_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-tournament-match-list-item:waiting-for-result"), " ");
} }
function TournamentMatchListItemComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TournamentMatchListItemComponent_ng_container_6_div_1_Template, 3, 3, "div", 10);
    i0.ɵɵtemplate(2, TournamentMatchListItemComponent_ng_container_6_div_2_Template, 3, 3, "div", 4);
    i0.ɵɵelementStart(3, "div", 11);
    i0.ɵɵtemplate(4, TournamentMatchListItemComponent_ng_container_6_div_4_Template, 3, 3, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isFFA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isFFA);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.hasMultipleContestants && ctx_r1.isFFA);
} }
function TournamentMatchListItemComponent_ng_container_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-tournament-match-list-item:waiting-for-opponent"), " ");
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const text_r17 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", text_r17, " ");
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 18);
    i0.ɵɵelementContainerEnd();
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_3_ng_container_1_Template, 2, 1, "ng-container", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_3_ng_container_3_Template, 2, 0, "ng-container", 5);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r10.matchChallenge$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(4, 4, ctx_r10.matchChallenge$));
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const text_r20 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", text_r20, " ");
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_4_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 18);
    i0.ɵɵelementContainerEnd();
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_4_ng_container_3_Template, 2, 0, "ng-container", 5);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r11.matchActionText$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(4, 4, ctx_r11.matchActionText$));
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-tournament-match-list-item:open-protest"), " ");
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const text_r23 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", text_r23, " ");
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 18);
    i0.ɵɵelementContainerEnd();
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_6_ng_container_1_Template, 2, 1, "ng-container", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_6_ng_container_3_Template, 2, 0, "ng-container", 5);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r13.matchActionText$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(4, 4, ctx_r13.matchActionText$));
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-tournament-match-list-item:open-protest-ticket"), " ");
} }
function TournamentMatchListItemComponent_ng_container_7_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_3_Template, 5, 6, "ng-container", 17);
    i0.ɵɵtemplate(4, TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_4_Template, 5, 6, "ng-container", 17);
    i0.ɵɵtemplate(5, TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_5_Template, 3, 3, "ng-container", 17);
    i0.ɵɵtemplate(6, TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_6_Template, 5, 6, "ng-container", 17);
    i0.ɵɵtemplate(7, TournamentMatchListItemComponent_ng_container_7_a_3_ng_container_7_Template, 3, 3, "ng-container", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0$2, i0.ɵɵpipeBind1(1, 8, ctx_r9.matchActionWaitingForOpponent$)))("locationHref", i0.ɵɵpipeBind1(2, 10, ctx_r9.matchActionLink$))("ngSwitch", ctx_r9.match.status);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngSwitchCase", ctx_r9.matchStates.Challenge);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r9.matchStates.Open);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r9.matchStates.Closed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r9.matchStates.Exception);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r9.matchStates.Protest);
} }
function TournamentMatchListItemComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵtemplate(2, TournamentMatchListItemComponent_ng_container_7_div_2_Template, 3, 3, "div", 10);
    i0.ɵɵtemplate(3, TournamentMatchListItemComponent_ng_container_7_a_3_Template, 8, 14, "a", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.hasMultipleContestants);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.hasMultipleContestants);
} }
class TournamentMatchListItemComponent {
    constructor(formatDate, linkService, store, translation) {
        this.formatDate = formatDate;
        this.linkService = linkService;
        this.store = store;
        this.translation = translation;
        this.matchStates = MatchStates;
    }
    ngOnChanges() {
        this.matchLink = this.linkService.match(this.leagueUrl, this.match.id);
        this.matchActionLink$ = of(this.linkService.matchSetup(this.leagueUrl, this.match.id));
        this.hasMultipleContestants = this.match.contestants.filter(contestant => Boolean(getName$1(contestant))).length > 1;
        if (!this.isFFA) {
            if (this.contestant && this.contestant.id !== getActualContestant(this.match.contestants[0]).id) {
                this.match.contestants.splice(1, 1, this.match.contestants.splice(0, 1, this.match.contestants[1])[0]);
            }
            this.contestantNames = this.match.contestants.map(contestant => getName$1(contestant));
        }
        if (this.isFFA) {
            this.store.dispatch(new LoadLeagueResultsOnceAction(+this.match.leagueId));
            this.matchResult$ = this.store.select(getLeagueResults(+this.match.leagueId)).pipe(filter(entryAvailable), map(results => results.entry.find(result => {
                return result.id === this.match.id;
            })));
        }
        if (this.hasMultipleContestants && anyPass([isOpen, isException])(this.match)) {
            this.store.dispatch(new LoadMatchResultReportOnceAction(this.match.id));
            this.store.dispatch(new LoadMatchDateReportOnceAction(this.match.id));
            this.matchSetupReport$ = this.store.select(getMatchDateReport(this.match.id)).pipe(filter(exists));
            this.matchResultReport$ = this.store.select(getMatchResultReport(this.match.id)).pipe(filter(exists));
            const matchData$ = combineLatest(this.matchResultReport$, this.matchSetupReport$).pipe(distinct(([resultReport, setupReport]) => ({
                setupSelfWantsToCancel: setupReport.entry && setupReport.entry.self.cancel && setupReport.entry.self.cancel.confirmed,
                setupOpponentWantsToCancel: setupReport.entry && setupReport.entry.opponent.cancel && setupReport.entry.opponent.cancel.confirmed,
                setupSelfWantsToMove: setupReport.entry && setupReport.entry.self.move && setupReport.entry.self.move.confirmed,
                setupOpponentWantsToMove: setupReport.entry && setupReport.entry.opponent.move && setupReport.entry.opponent.move.confirmed,
                resultSelfConfirmed: resultReport.entry && resultReport.entry.contestants.self.resultConfirmed,
                resultOpponentConfirmed: resultReport.entry && resultReport.entry.contestants.opponent.resultConfirmed,
                isLoading: resultReport.loading && !resultReport.entry && setupReport.loading && !setupReport.entry,
            })), shareReplay());
            this.matchActionText$ = matchData$.pipe(map(({ setupSelfWantsToCancel, setupOpponentWantsToCancel, setupSelfWantsToMove, setupOpponentWantsToMove, resultSelfConfirmed, resultOpponentConfirmed, isLoading, }) => {
                if (!setupSelfWantsToCancel && setupOpponentWantsToCancel) {
                    return this.translation.translate("user-tournament-match-list-item:confirm-match-deletion", {});
                }
                else if (setupSelfWantsToCancel && !setupOpponentWantsToCancel) {
                    return this.translation.translate("user-tournament-match-list-item:cancel-match-deletion", {});
                }
                else if (setupSelfWantsToMove && !setupOpponentWantsToMove) {
                    return this.translation.translate("user-tournament-match-list-item:cancel-match-move", {});
                }
                else if (!setupSelfWantsToMove && setupOpponentWantsToMove) {
                    return this.translation.translate("user-tournament-match-list-item:confirm-date", {});
                }
                else if (!resultSelfConfirmed && resultOpponentConfirmed) {
                    return this.translation.translate("user-tournament-match-list-item:confirm-result", {});
                }
                else if (resultSelfConfirmed && !resultOpponentConfirmed) {
                    return this.translation.translate("user-tournament-match-list-item:waiting-for-opponent", {});
                }
                else if (isLoading) {
                    return "";
                }
                return this.translation.translate("user-tournament-match-list-item:enter-result", {});
            }));
            this.matchActionLink$ = matchData$.pipe(map(({ setupSelfWantsToCancel, setupOpponentWantsToCancel, setupSelfWantsToMove, setupOpponentWantsToMove }) => {
                if (setupSelfWantsToCancel && !setupOpponentWantsToCancel) {
                    return this.linkService.matchDeleteCancel(this.leagueUrl, this.match.id);
                }
                else if (!setupSelfWantsToCancel && setupOpponentWantsToCancel) {
                    return this.linkService.matchDelete(this.leagueUrl, this.match.id);
                }
                else if (setupSelfWantsToMove && !setupOpponentWantsToMove) {
                    return this.linkService.matchMoveCancel(this.leagueUrl, this.match.id);
                }
                else if (!setupSelfWantsToMove && setupOpponentWantsToMove) {
                    return this.linkService.matchMove(this.leagueUrl, this.match.id);
                }
                return this.linkService.matchSetup(this.leagueUrl, this.match.id);
            }));
            this.matchActionWaitingForOpponent$ = matchData$.pipe(map(({ resultSelfConfirmed, setupSelfWantsToMove, setupOpponentWantsToMove }) => resultSelfConfirmed && !setupSelfWantsToMove && !setupOpponentWantsToMove));
        }
        if (this.hasMultipleContestants && isChallenge(this.match)) {
            this.store.dispatch(new LoadMatchChallengeReportOnceAction(this.match.id));
            this.matchChallengeReport$ = this.store.select(getMatchChallengeReport(this.match.id)).pipe(filter(exists));
            this.matchChallenge$ = this.matchChallengeReport$.pipe(distinct(report => {
                const challengeByUser = report.entry && report.entry.parameters.begin.setByUser;
                const challengeByOpponent = report.entry && report.entry.parameters.begin.setByOpponent;
                const isLoading = report.loading && !report.loading;
                if (challengeByUser) {
                    return this.translation.translate("user-tournament-match-list-item:waiting-for-opponent", {});
                }
                else if (challengeByOpponent) {
                    return this.translation.translate("user-tournament-match-list-item:confirm-date", {});
                }
                else if (isLoading) {
                    return "";
                }
                return this.translation.translate("user-tournament-match-list-item:enter-result", {});
            }));
            this.matchActionWaitingForOpponent$ = this.matchChallengeReport$.pipe(distinct(report => report.entry && report.entry.parameters.begin.setByUser));
        }
        if (this.hasMultipleContestants && isProtest(this.match)) {
            this.matchActionLink$ = of(this.linkService.matchProtest(this.leagueUrl, this.match.id));
        }
    }
}
TournamentMatchListItemComponent.ɵfac = function TournamentMatchListItemComponent_Factory(t) { return new (t || TournamentMatchListItemComponent)(i0.ɵɵdirectiveInject(i1.FormatDate), i0.ɵɵdirectiveInject(i1.LinkService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.TranslateService)); };
TournamentMatchListItemComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TournamentMatchListItemComponent, selectors: [["user-tournament-match-list-item"]], inputs: { match: "match", leagueUrl: "leagueUrl", contestant: "contestant", isFFA: "isFFA", isResultsEnabled: "isResultsEnabled" }, features: [i0.ɵɵNgOnChangesFeature], decls: 9, vars: 6, consts: [[1, "c-user-tournament-match-list-item"], ["user-match-label", "", 3, "matchState"], ["user-match-date", ""], [3, "date"], ["user-match-name", "", 4, "ngIf"], [4, "ngIf"], [1, "c-user-tournament-match-list-item--divider"], ["user-match-name", ""], [1, "c-user-match-name__link", 3, "locationHref", "title"], [3, "ngClass"], ["class", "c-user-tournament-match-list-item__waiting", 4, "ngIf"], ["user-match-action", ""], [1, "c-user-tournament-match-list-item__waiting"], [1, "c-user-match-name__link", 3, "locationHref"], [1, "u-color-saturated"], [3, "ngClass", "locationHref", "ngSwitch", 4, "ngIf"], [3, "ngClass", "locationHref", "ngSwitch"], [4, "ngSwitchCase"], [1, "c-skeleton__text", "c-skeleton__text--small"]], template: function TournamentMatchListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelement(4, "format-date", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, TournamentMatchListItemComponent_div_5_Template, 11, 18, "div", 4);
        i0.ɵɵtemplate(6, TournamentMatchListItemComponent_ng_container_6_Template, 5, 3, "ng-container", 5);
        i0.ɵɵtemplate(7, TournamentMatchListItemComponent_ng_container_7_Template, 4, 2, "ng-container", 5);
        i0.ɵɵelement(8, "hr", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matchState", ctx.match.status);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.match.status, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("date", ctx.match.beginAt);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.contestantNames);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isResultsEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isResultsEnabled);
    } }, directives: [UserMatchLabelComponent, MatchDateComponent, i1.FormatDateComponent, i6.NgIf, MatchNameComponent, i1.LocationDirective, i6.NgClass, MatchActionComponent, i6.NgSwitch, i6.NgSwitchCase], pipes: [i3.TranslatePipe, i6.AsyncPipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TournamentMatchListItemComponent, [{
        type: Component,
        args: [{
                selector: "user-tournament-match-list-item",
                templateUrl: "./tournament-match-list-item.component.html",
                styleUrls: ["./tournament-match-list-item.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.FormatDate }, { type: i1.LinkService }, { type: i2.Store }, { type: i3.TranslateService }]; }, { match: [{
            type: Input
        }], leagueUrl: [{
            type: Input
        }], contestant: [{
            type: Input
        }], isFFA: [{
            type: Input
        }], isResultsEnabled: [{
            type: Input
        }] }); })();

const _c0$1 = ["user-closed-matches", ""];
const _c1$1 = ["*"];
class ClosedMatchesComponent {
    constructor() { }
    get useClass() {
        return true;
    }
}
ClosedMatchesComponent.ɵfac = function ClosedMatchesComponent_Factory(t) { return new (t || ClosedMatchesComponent)(); };
ClosedMatchesComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ClosedMatchesComponent, selectors: [["", "user-closed-matches", ""]], hostVars: 2, hostBindings: function ClosedMatchesComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("c-user-closed-matches", ctx.useClass);
    } }, attrs: _c0$1, ngContentSelectors: _c1$1, decls: 1, vars: 0, template: function ClosedMatchesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClosedMatchesComponent, [{
        type: Component,
        args: [{
                selector: "[user-closed-matches]",
                templateUrl: "./closed-matches.component.html",
                styleUrls: ["./closed-matches.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return []; }, { useClass: [{
            type: HostBinding,
            args: ["class.c-user-closed-matches"]
        }] }); })();

const _c0 = function (a0) { return { "c-user-tournament-match-list-item": a0 }; };
const _c1 = function (a0) { return { count: a0 }; };
class TournamentClosedMatchesComponent {
    constructor() { }
}
TournamentClosedMatchesComponent.ɵfac = function TournamentClosedMatchesComponent_Factory(t) { return new (t || TournamentClosedMatchesComponent)(); };
TournamentClosedMatchesComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TournamentClosedMatchesComponent, selectors: [["user-tournament-closed-matches"]], inputs: { moreMatchesLink: "moreMatchesLink", totalMatches: "totalMatches", openMatchesLength: "openMatchesLength" }, decls: 4, vars: 10, consts: [["user-closed-matches", "", 1, "c-user-tournament-closed-matches", 3, "ngClass"], [1, "c-user-tournament-closed-matches__link", 3, "locationHref"]], template: function TournamentClosedMatchesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "a", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx.openMatchesLength));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("locationHref", ctx.moreMatchesLink);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 3, "user-tournament-closed-matches:more-closed-matches", i0.ɵɵpureFunction1(8, _c1, ctx.totalMatches)), " ");
    } }, directives: [ClosedMatchesComponent, i6.NgClass, i1.LocationDirective], pipes: [i3.TranslatePipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TournamentClosedMatchesComponent, [{
        type: Component,
        args: [{
                selector: "user-tournament-closed-matches",
                templateUrl: "./tournament-closed-matches.component.html",
                styleUrls: ["./tournament-closed-matches.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return []; }, { moreMatchesLink: [{
            type: Input
        }], totalMatches: [{
            type: Input
        }], openMatchesLength: [{
            type: Input
        }] }); })();

function TournamentMatchListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function TournamentMatchListComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function TournamentMatchListComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "user-tournament-no-matches", 6);
    i0.ɵɵlistener("action", function TournamentMatchListComponent_ng_template_3_Template_user_tournament_no_matches_action_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.navigateToRanking(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isEliminated", ctx_r3.contestant.state === ctx_r3.contestantStates.Finished)("isLongRunning", ctx_r3.isLongRunning)("isTeamLeague", ctx_r3.isTeamLeague)("team", ctx_r3.team)("league", ctx_r3.league)("contestant", ctx_r3.contestant);
} }
function TournamentMatchListComponent_ng_template_5_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "user-tournament-team-link", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("team", ctx_r10.team);
} }
function TournamentMatchListComponent_ng_template_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "user-tournament-match-list-item", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const match_r12 = ctx.$implicit;
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("match", match_r12)("isFFA", ctx_r11.isFFA)("leagueUrl", ctx_r11.league.uri)("contestant", ctx_r11.contestant)("isResultsEnabled", ctx_r11.isResultsEnabled);
} }
function TournamentMatchListComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, TournamentMatchListComponent_ng_template_5_div_0_Template, 2, 1, "div", 7);
    i0.ɵɵtemplate(1, TournamentMatchListComponent_ng_template_5_ng_container_1_Template, 2, 5, "ng-container", 8);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r5.isTeamLeague && ctx_r5.team);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5.userOpenLeagueMatches)("ngForTrackBy", ctx_r5.trackById);
} }
function TournamentMatchListComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "user-tournament-closed-matches", 12);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("moreMatchesLink", ctx_r7.moreMatchesLink)("totalMatches", ctx_r7.userClosedLeagueMatches.length)("openMatchesLength", ctx_r7.userOpenLeagueMatches.length);
} }
class TournamentMatchListComponent {
    constructor(linkService, location, store) {
        this.linkService = linkService;
        this.location = location;
        this.store = store;
        this.userOpenLeagueMatches = [];
        this.userClosedLeagueMatches = [];
        this.contestantStates = ContestantStates;
    }
    ngOnChanges() {
        this.isTeamLeague = isTeam(this.league);
        this.isFFA = isFFA(this.league);
        this.isLongRunning = isLongRunning(this.league);
        this.moreMatchesLink = this.team
            ? this.linkService.teamClosedMatches(+this.team.id, null, this.league.id)
            : this.linkService.playerClosedMatches(this.userId, null, this.league.id);
        this.userOpenLeagueMatches = this.matches.filter(match => [MatchStates.Open, MatchStates.Challenge, MatchStates.Protest, MatchStates.Exception].indexOf(match.status) !== -1);
        this.userOpenLeagueMatches = this.matches.filter(anyPass([isOpen, isChallenge, isProtest, isException]));
        this.userClosedLeagueMatches = this.matches.filter(isClosed);
    }
    trackById(item, index) {
        return item.entry ? item.entry.id : index;
    }
    navigateToRanking() {
        this.location.go(this.linkService.ranking(this.league.uri));
    }
}
TournamentMatchListComponent.ɵfac = function TournamentMatchListComponent_Factory(t) { return new (t || TournamentMatchListComponent)(i0.ɵɵdirectiveInject(i1.LinkService), i0.ɵɵdirectiveInject(i1.Location), i0.ɵɵdirectiveInject(i2.Store)); };
TournamentMatchListComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TournamentMatchListComponent, selectors: [["user-tournament-match-list"]], inputs: { userId: "userId", league: "league", matches: "matches", contestant: "contestant", isResultsEnabled: "isResultsEnabled", team: "team" }, features: [i0.ɵɵNgOnChangesFeature], decls: 9, vars: 5, consts: [[1, "c-user-tournament-match-list"], [4, "ngIf", "ngIfThen", "ngIfElse"], [4, "ngIf", "ngIfThen"], ["noOpenMatches", ""], ["hasOpenMatches", ""], ["hasClosedMatches", ""], [3, "isEliminated", "isLongRunning", "isTeamLeague", "team", "league", "contestant", "action"], ["class", "c-user-tournament-match-list__team", 4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "c-user-tournament-match-list__team"], [3, "team"], [3, "match", "isFFA", "leagueUrl", "contestant", "isResultsEnabled"], [3, "moreMatchesLink", "totalMatches", "openMatchesLength"]], template: function TournamentMatchListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, TournamentMatchListComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
        i0.ɵɵtemplate(2, TournamentMatchListComponent_ng_container_2_Template, 1, 0, "ng-container", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, TournamentMatchListComponent_ng_template_3_Template, 1, 6, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, TournamentMatchListComponent_ng_template_5_Template, 2, 3, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(7, TournamentMatchListComponent_ng_template_7_Template, 1, 3, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(4);
        const _r4 = i0.ɵɵreference(6);
        const _r6 = i0.ɵɵreference(8);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.userOpenLeagueMatches.length)("ngIfThen", _r4)("ngIfElse", _r2);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.userClosedLeagueMatches.length)("ngIfThen", _r6);
    } }, directives: [i6.NgIf, TournamentNoMatchesComponent, i6.NgForOf, TournamentTeamLinkComponent, TournamentMatchListItemComponent, TournamentClosedMatchesComponent], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TournamentMatchListComponent, [{
        type: Component,
        args: [{
                selector: "user-tournament-match-list",
                templateUrl: "./tournament-match-list.component.html",
                styleUrls: ["./tournament-match-list.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.LinkService }, { type: i1.Location }, { type: i2.Store }]; }, { userId: [{
            type: Input
        }], league: [{
            type: Input
        }], matches: [{
            type: Input
        }], contestant: [{
            type: Input
        }], isResultsEnabled: [{
            type: Input
        }], team: [{
            type: Input
        }] }); })();

function TournamentListItemComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:ongoing"), " ");
} }
function TournamentListItemComponent_league_date_time_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "league-date-time", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("leagueType", ctx_r1.league.type)("leagueState", ctx_r1.league.state)("dateTime", ctx_r1.league.timeline == null ? null : ctx_r1.league.timeline.inProgress == null ? null : ctx_r1.league.timeline.inProgress.begin);
} }
function TournamentListItemComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:live-now"), " ");
} }
function TournamentListItemComponent_user_tournament_match_list_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "user-tournament-match-list", 12);
} if (rf & 2) {
    const contestant_r4 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("userId", ctx_r3.userId)("league", ctx_r3.league)("matches", contestant_r4.matches)("isResultsEnabled", ctx_r3.isResultsEnabled)("contestant", contestant_r4.contestant)("team", contestant_r4.team);
} }
class TournamentListItemComponent {
    constructor(links) {
        this.links = links;
    }
    ngOnChanges() {
        this.leagueLink = this.links.league(this.league.id, this.league.uri);
        this.liveNow = isInProgress(this.league);
        this.isLadder = isLadder(this.league);
        this.isResultsEnabled = isEnterResultEnabled(this.league);
        if (this.contestants) {
            this.contestantsWithMatches = this.contestants.map(contestant => {
                const matches = this.matches.filter(match => match.contestants.find(cont => (isTeam$1(cont) ? +cont.team.id === getId(contestant) : +cont.user.id === getId(contestant))));
                let team = {};
                if (this.teams) {
                    team = this.teams.find(t => getId$1(t) === getId(contestant));
                }
                return { contestant, matches, team };
            });
            this.contestantsWithMatches = contestantSort(this.contestantsWithMatches);
        }
    }
}
TournamentListItemComponent.ɵfac = function TournamentListItemComponent_Factory(t) { return new (t || TournamentListItemComponent)(i0.ɵɵdirectiveInject(i1.LinkService)); };
TournamentListItemComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TournamentListItemComponent, selectors: [["user-tournament-list-item"]], inputs: { userId: "userId", league: "league", matches: "matches", contestants: "contestants", teams: "teams" }, features: [i0.ɵɵNgOnChangesFeature], decls: 11, vars: 8, consts: [[1, "c-user-tournament-list-item"], [1, "c-user-tournament-list-item__league--timeline"], [4, "ngIf"], ["class", "c-user-tournament-list-item__league--timeline__date", 3, "leagueType", "leagueState", "dateTime", 4, "ngIf"], [1, "c-user-tournament-list-item__league--name"], [1, "c-user-tournament-list-item__icon", "c-user-tournament-list-item__icon--game", 3, "gameId"], [1, "c-user-tournament-list-item__link", 3, "locationHref", "title"], ["class", "c-user-tournament-list-item__live--indicator", 4, "ngIf"], [1, "c-user-tournament-list-item__matches"], ["class", "c-user-tournament-match-list", 3, "userId", "league", "matches", "isResultsEnabled", "contestant", "team", 4, "ngFor", "ngForOf"], [1, "c-user-tournament-list-item__league--timeline__date", 3, "leagueType", "leagueState", "dateTime"], [1, "c-user-tournament-list-item__live--indicator"], [1, "c-user-tournament-match-list", 3, "userId", "league", "matches", "isResultsEnabled", "contestant", "team"]], template: function TournamentListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, TournamentListItemComponent_div_2_Template, 3, 3, "div", 2);
        i0.ɵɵtemplate(3, TournamentListItemComponent_league_date_time_3_Template, 1, 3, "league-date-time", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelement(5, "game-icon", 5);
        i0.ɵɵelementStart(6, "a", 6);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, TournamentListItemComponent_div_8_Template, 3, 3, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵtemplate(10, TournamentListItemComponent_user_tournament_match_list_10_Template, 1, 6, "user-tournament-match-list", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.liveNow && ctx.isLadder);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.liveNow);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("gameId", ctx.league.gameId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("locationHref", ctx.leagueLink)("title", ctx.league.name.full);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.league.name.full, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.liveNow && !ctx.isLadder);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.contestantsWithMatches);
    } }, directives: [i6.NgIf, i1.GameIconComponent, i1.LocationDirective, i6.NgForOf, i3$1.DateTimeComponent, TournamentMatchListComponent], pipes: [i3.TranslatePipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TournamentListItemComponent, [{
        type: Component,
        args: [{
                selector: "user-tournament-list-item",
                templateUrl: "./tournament-list-item.component.html",
                styleUrls: ["./tournament-list-item.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.LinkService }]; }, { userId: [{
            type: Input
        }], league: [{
            type: Input
        }], matches: [{
            type: Input
        }], contestants: [{
            type: Input
        }], teams: [{
            type: Input
        }] }); })();

class TournamentListItemSkeletonComponent {
}
TournamentListItemSkeletonComponent.ɵfac = function TournamentListItemSkeletonComponent_Factory(t) { return new (t || TournamentListItemSkeletonComponent)(); };
TournamentListItemSkeletonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TournamentListItemSkeletonComponent, selectors: [["user-tournament-list-item-skeleton"]], decls: 5, vars: 0, consts: [[1, "c-user-tournament-list-item"], [1, "c-skeleton", "c-user-tournament-list-item__header"], [1, "c-skeleton__text", "c-skeleton__text--small"], ["gameId", "0", 1, "c-user-tournament-list-item__icon", "c-user-tournament-list-item__icon--game"]], template: function TournamentListItemSkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "div", 2);
        i0.ɵɵelement(3, "game-icon", 3);
        i0.ɵɵelement(4, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } }, directives: [i1.GameIconComponent], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TournamentListItemSkeletonComponent, [{
        type: Component,
        args: [{
                selector: "user-tournament-list-item-skeleton",
                templateUrl: "./tournament-list-item-skeleton.component.html",
                styleUrls: ["./tournament-list-item-skeleton.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

function TournamentListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function TournamentListComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function TournamentListComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function TournamentListComponent_ng_template_7_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function TournamentListComponent_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TournamentListComponent_ng_template_7_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r14 = i0.ɵɵreference(7);
    const _r12 = i0.ɵɵreference(5);
    const ctx_r9 = i0.ɵɵnextContext();
    let tmp_0_0 = null;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_0_0 = i0.ɵɵpipeBind1(2, 3, ctx_r9.sortedUpcomingLeagues$)) == null ? null : tmp_0_0.length)("ngIfThen", _r14)("ngIfElse", _r12);
} }
function TournamentListComponent_ng_template_7_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "empty-call-action", 11);
    i0.ɵɵlistener("action", function TournamentListComponent_ng_template_7_ng_template_2_Template_empty_call_action_action_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.navigateToLogin(); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actionLabel", i0.ɵɵpipeBind1(2, 2, "user-tournament-list:login-action-label"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "user-tournament-list:login-action-description"), " ");
} }
function TournamentListComponent_ng_template_7_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "empty-call-action", 11);
    i0.ɵɵlistener("action", function TournamentListComponent_ng_template_7_ng_template_4_Template_empty_call_action_action_1_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.navigateToGames(); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actionLabel", i0.ɵɵpipeBind1(2, 2, "user-tournament-list:no-leagues-action-label"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "user-tournament-list:no-leagues-action-description"), " ");
} }
function TournamentListComponent_ng_template_7_ng_template_6_ng_container_0_user_tournament_list_item_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "user-tournament-list-item", 15);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const league_r22 = i0.ɵɵnextContext().$implicit;
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("userId", i0.ɵɵpipeBind1(1, 5, ctx_r23.user$).entry.id)("league", league_r22.league.entry)("matches", league_r22.matches.entry)("contestants", league_r22.contestants)("teams", league_r22.teams);
} }
function TournamentListComponent_ng_template_7_ng_template_6_ng_container_0_inline_error_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), " ");
} }
function TournamentListComponent_ng_template_7_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TournamentListComponent_ng_template_7_ng_template_6_ng_container_0_user_tournament_list_item_1_Template, 2, 7, "user-tournament-list-item", 13);
    i0.ɵɵtemplate(2, TournamentListComponent_ng_template_7_ng_template_6_ng_container_0_inline_error_2_Template, 3, 3, "inline-error", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const league_r22 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", league_r22.league.entry);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", league_r22.league.error);
} }
function TournamentListComponent_ng_template_7_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, TournamentListComponent_ng_template_7_ng_template_6_ng_container_0_Template, 3, 2, "ng-container", 12);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(1, 2, ctx_r15.sortedUpcomingLeagues$))("ngForTrackBy", ctx_r15.trackById);
} }
function TournamentListComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, TournamentListComponent_ng_template_7_ng_container_0_Template, 3, 5, "ng-container", 5);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵtemplate(2, TournamentListComponent_ng_template_7_ng_template_2_Template, 5, 6, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, TournamentListComponent_ng_template_7_ng_template_4_Template, 5, 6, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, TournamentListComponent_ng_template_7_ng_template_6_Template, 2, 4, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r10 = i0.ɵɵreference(3);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx_r4.user$).entry)("ngIfElse", _r10);
} }
function TournamentListComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "user-tournament-list-item-skeleton");
    i0.ɵɵelement(2, "user-tournament-list-item-skeleton");
    i0.ɵɵelement(3, "user-tournament-list-item-skeleton");
    i0.ɵɵelement(4, "user-tournament-list-item-skeleton");
    i0.ɵɵelement(5, "user-tournament-list-item-skeleton");
    i0.ɵɵelementEnd();
} }
function TournamentListComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "inline-error");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "commons:data-fetch-error"), " ");
} }
class TournamentListComponent {
    constructor(store, links, location, players, leagueResource, config) {
        this.store = store;
        this.links = links;
        this.location = location;
        this.players = players;
        this.leagueResource = leagueResource;
        this.config = config;
    }
    ngOnInit() {
        this.user$ = this.store.select(getUser).pipe(filter(exists));
        const userId$ = this.user$.pipe(filter(entryAvailable), distinct(user => +user.entry.id));
        const playerLeagues$ = userId$.pipe(switchMap(id => this.players.getLeaguesOfPlayer(id)), shareReplay(1));
        const leagueIds$ = playerLeagues$.pipe(map(leagues => leagues.map(({ leagueId }) => leagueId)), map((leagueIds) => {
            return leagueIds.reduce((acc, curr) => {
                if (acc[acc.length - 1].length < 100) {
                    acc[acc.length - 1].push(curr);
                }
                else {
                    acc.push([curr]);
                }
                return acc;
            }, [[]]);
        }));
        const leagues$ = leagueIds$.pipe(switchMap((leagueIds) => {
            if (!leagueIds.length || !leagueIds[0].length) {
                return of([[]]);
            }
            return combineLatest(leagueIds.map(ids => this.leagueResource.queryLeagues({
                states: ["upcoming", "inprogress"],
                leagueIds: ids,
                path: `/${this.config.navnode}`,
            })));
        }), map(leagues => [].concat.apply([], leagues)), tap(leagues => leagues.forEach(league => this.store.dispatch(new LoadLeagueCompleteAction(league.id, league)))), shareReplay(1));
        const leagueContestants$ = combineLatest(leagues$, userId$).pipe(switchMap(([leagues, userId]) => {
            if (!leagues.length) {
                return [];
            }
            return combineLatest(leagues.map(league => {
                this.store.dispatch(new LoadContestantsOnceAction(league.id, userId));
                return this.store.select(getContestants(league.id, userId)).pipe(filter(entryAvailable), map(contestants => (Object.assign(Object.assign({}, league), { contestants: contestants.entry }))));
            }));
        }), map(leagueContestant => leagueContestant.reduce((obj, curr) => (Object.assign(Object.assign({}, obj), { [curr.id]: curr.contestants })), {})), startWith([]));
        this.leagues$ = leagues$.pipe(switchMap(leagues => (leagues.length ? combineLatest(leagues.map(league => this.store.select(getLeague(league.id)))) : of([]))), filter((leagues) => leagues.filter(league => Boolean(league.error || league.entry)).length === leagues.length), map(leagues => leagues.filter(league => league.entry && league.entry.uri.indexOf(this.config.navnode) !== -1)), startWith(null));
        const upcomingLeagues$ = this.leagues$.pipe(map(leagues => (leagues ? leagues.filter(league => league.entry && !isFinished(league.entry)) : leagues)));
        const matches$ = upcomingLeagues$.pipe(filter(exists), withLatestFrom(userId$), switchMap(([leagues, userId]) => combineLatest(leagues.map(league => {
            const leagueId = league.entry.id;
            return this.players.getMatchesOfPlayer(userId, { leagueIds: [leagueId] }).pipe(map(matches => ({ loading: false, error: null, entry: matches })), startWith(createLoadingEntryState()), map(matches => (Object.assign(Object.assign({}, matches), { entry: matches.entry ? matchSort(matches.entry) : matches.entry }))), map(matches => ({ [leagueId]: matches })));
        }))), map(matches => Object.assign({}, ...matches)), startWith({}), shareReplay(1));
        const teams$ = combineLatest(leagueContestants$, upcomingLeagues$).pipe(switchMap(([contestants, leagues]) => {
            if (!leagues || !contestants || contestants.length <= 0) {
                return [];
            }
            return combineLatest(leagues.map(league => combineLatest(contestants[league.entry.id].map(contestant => {
                if (isTeam(league.entry)) {
                    this.store.dispatch(new LoadTeamOnceAction(getId(contestant)));
                    return this.store.select(getTeam(getId(contestant))).pipe(filter(entryAvailable), map(team => ({ league: league.entry, team: team.entry })));
                }
                return of({ league: league.entry, team: {} });
            }))));
        }), map(leagueContestants => leagueContestants
            .reduce((arr, curr) => arr.concat(curr))
            .reduce((obj, curr) => {
            if (obj[curr.league.id]) {
                obj[curr.league.id].push(curr.team);
            }
            else {
                obj[curr.league.id] = [curr.team];
            }
            return obj;
        }, {})), startWith([]));
        this.upcomingLeagues$ = combineLatest(leagueContestants$, upcomingLeagues$, matches$, teams$).pipe(map(([contestantMap, leagues, matches, teams]) => {
            if (!leagues) {
                return null;
            }
            return leagues.map(league => {
                return {
                    league: league,
                    matches: league.entry && matches[league.entry.id] ? matches[league.entry.id] : createLoadingEntryState(),
                    contestants: league.entry ? contestantMap[league.entry.id] : [],
                    teams: league.entry ? teams[league.entry.id] : [],
                };
            });
        }));
        this.isLoading$ = this.isLoading();
        this.hasError$ = this.hasError();
        this.isReady$ = this.isReady();
        this.sortedUpcomingLeagues$ = this.upcomingLeagues$.pipe(filter(Boolean), withLatestFrom(this.isLoading$), filter(([, isLoading]) => !isLoading), map(([leagues]) => leagues), map(leagueSort));
    }
    navigateToLogin() {
        this.location.go(this.links.login());
    }
    navigateToGames() {
        this.location.go(this.links.games());
    }
    trackById(index, item) {
        return item.league.entry ? item.league.entry.id : index; // index as fallback is safe here, since legaue ids are in the thousands.
    }
    hasError() {
        return combineLatest(this.user$).pipe(distinct(([userData]) => {
            const data = [userData];
            return data.filter(entry => entry && entry.error).length !== 0;
        }));
    }
    isLoading() {
        return combineLatest(this.upcomingLeagues$, this.user$).pipe(distinct(([leagueData, userData]) => {
            /**
             * We need to wait until every league / match has been loaded before we can sort them.
             * This is because we do not want the user to have moving leagues and worsen his experience.
             *
             * If they are finished loading though, we will show inline errors if the route errord
             */
            if (!leagueData) {
                return true;
            }
            const leaguesData = leagueData.map(league => league.league);
            const matchData = leagueData.reduce((matches, league) => {
                return [...matches, league.matches];
            }, []);
            const data = [userData, ...matchData, ...leaguesData];
            return data.filter(entry => entry && entry.loading && !entry.entry).length !== 0;
        }), startWith(true));
    }
    isReady() {
        return combineLatest(this.isLoading$, this.hasError$).pipe(distinct(([loading, error]) => Boolean(!loading && !error)));
    }
}
TournamentListComponent.ɵfac = function TournamentListComponent_Factory(t) { return new (t || TournamentListComponent)(i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.LinkService), i0.ɵɵdirectiveInject(i1.Location), i0.ɵɵdirectiveInject(i3$2.PlayerResource), i0.ɵɵdirectiveInject(i3$2.LeagueResource), i0.ɵɵdirectiveInject(BASE_CONFIG)); };
TournamentListComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TournamentListComponent, selectors: [["user-tournament-list"]], decls: 13, vars: 12, consts: [[1, "c-user-tournament-list"], [4, "ngIf", "ngIfThen"], ["ready", ""], ["loading", ""], ["error", ""], [4, "ngIf", "ngIfElse"], ["loggedOut", ""], ["noLeagues", ""], ["hasLeagues", ""], [4, "ngIf", "ngIfThen", "ngIfElse"], [1, "c-user-tournament-list__tournaments"], [3, "actionLabel", "action"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "userId", "league", "matches", "contestants", "teams", 4, "ngIf"], [4, "ngIf"], [3, "userId", "league", "matches", "contestants", "teams"]], template: function TournamentListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵtemplate(1, TournamentListComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
        i0.ɵɵpipe(2, "async");
        i0.ɵɵtemplate(3, TournamentListComponent_ng_container_3_Template, 1, 0, "ng-container", 1);
        i0.ɵɵpipe(4, "async");
        i0.ɵɵtemplate(5, TournamentListComponent_ng_container_5_Template, 1, 0, "ng-container", 1);
        i0.ɵɵpipe(6, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, TournamentListComponent_ng_template_7_Template, 8, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(9, TournamentListComponent_ng_template_9_Template, 6, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(11, TournamentListComponent_ng_template_11_Template, 4, 3, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(8);
        const _r5 = i0.ɵɵreference(10);
        const _r7 = i0.ɵɵreference(12);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 6, ctx.isReady$))("ngIfThen", _r3);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 8, ctx.isLoading$))("ngIfThen", _r5);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 10, ctx.hasError$))("ngIfThen", _r7);
    } }, directives: [i6.NgIf, i1.EmptyCallActionComponent, i6.NgForOf, TournamentListItemComponent, i1.InlineErrorComponent, TournamentListItemSkeletonComponent], pipes: [i6.AsyncPipe, i3.TranslatePipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TournamentListComponent, [{
        type: Component,
        args: [{
                selector: "user-tournament-list",
                templateUrl: "./tournament-list.component.html",
                styleUrls: ["./tournament-list.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.LinkService }, { type: i1.Location }, { type: i3$2.PlayerResource }, { type: i3$2.LeagueResource }, { type: undefined, decorators: [{
                type: Inject,
                args: [BASE_CONFIG]
            }] }]; }, null); })();

const tournamentListTexts = {
    "user-tournament-list:upcoming-title": "My Competitions",
    "user-tournament-list:no-leagues-action-description": "Looks like you have no upcoming or in progress tournaments at the moment. Why not sign up to some?",
    "user-tournament-list:no-leagues-action-label": "Find tournaments",
    "user-tournament-list:login-action-description": "Please log in to see your tournaments.",
    "user-tournament-list:login-action-label": "Login/Register",
    "commons:live-now": "Live now",
    "commons:ongoing": "Ongoing",
};

const tournamentMatchListItemTexts = {
    "user-tournament-match-list-item:confirm-result": "Confirm result",
    "user-tournament-match-list-item:enter-result": "Enter result",
    "user-tournament-match-list-item:confirm-date": "Confirm date",
    "user-tournament-match-list-item:enter-date": "Enter date",
    "user-tournament-match-list-item:open-protest": "Open protest",
    "user-tournament-match-list-item:open-protest-ticket": "View protest",
    "user-tournament-match-list-item:waiting-for-opponent": "Waiting for opponent",
    "user-tournament-match-list-item:cancel-match-move": "Cancel match move",
    "user-tournament-match-list-item:tbd": "to be defined",
    "user-tournament-match-list-item:waiting-for-result": "Waiting for result",
};

const tournamentMatchListTexts = {};

const tournamentClosedMatchesTexts = {
    "user-tournament-closed-matches:more-closed-matches": "{count, select, 1{+ 1 more closed match} other{+ {count} more closed matches}}",
};

const tournamentNoMatchesTexts = {
    "user-tournament-no-matches:match-waiting": "Matches will commence soon.",
    "user-tournament-no-matches:waiting-for-checkin": "Waiting for check in.",
    "user-tournament-no-matches:checkin-is-open": "Check in is now open.",
    "user-tournament-no-matches:challenge-someone": "Challenge someone",
    "user-tournament-no-matches:no-upcoming-matches": "Looks like you have no upcoming matches.",
    "league-interaction:you-finished-nth": "You finished in {place} place",
    "user-tournament-no-matches:sign-up-pending": "Your sign-up is pending admin verification.",
    "user-tournament-no-matches:waiting-for-tournament-start": "Waiting for tournament start",
    "user-tournament-no-matches:you-have-finished": "You have finished in this tournament",
};

class UserLeagueModule {
}
UserLeagueModule.ɵfac = function UserLeagueModule_Factory(t) { return new (t || UserLeagueModule)(); };
UserLeagueModule.ɵmod = i0.ɵɵdefineNgModule({ type: UserLeagueModule });
UserLeagueModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, CommonsComponentModule, CommonsLocationModule, CommonsErrorModule, LeagueModule, TranslationModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UserLeagueModule, { declarations: [TournamentListComponent,
        TournamentListItemComponent,
        TournamentListItemSkeletonComponent,
        TournamentMatchListComponent,
        TournamentMatchListItemComponent,
        UserMatchLabelComponent,
        MatchDateComponent,
        ClosedMatchesComponent,
        MatchActionComponent,
        MatchNameComponent,
        TournamentClosedMatchesComponent,
        TournamentNoMatchesComponent,
        TournamentTeamLinkComponent], imports: [CommonModule, CommonsComponentModule, CommonsLocationModule, CommonsErrorModule, LeagueModule, TranslationModule], exports: [TournamentListComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserLeagueModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, CommonsComponentModule, CommonsLocationModule, CommonsErrorModule, LeagueModule, TranslationModule],
                declarations: [
                    TournamentListComponent,
                    TournamentListItemComponent,
                    TournamentListItemSkeletonComponent,
                    TournamentMatchListComponent,
                    TournamentMatchListItemComponent,
                    UserMatchLabelComponent,
                    MatchDateComponent,
                    ClosedMatchesComponent,
                    MatchActionComponent,
                    MatchNameComponent,
                    TournamentClosedMatchesComponent,
                    TournamentNoMatchesComponent,
                    TournamentTeamLinkComponent,
                ],
                exports: [TournamentListComponent],
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ClosedMatchesComponent, MatchActionComponent, MatchDateComponent, MatchNameComponent, TournamentClosedMatchesComponent, TournamentListComponent, TournamentListItemComponent, TournamentListItemSkeletonComponent, TournamentMatchListComponent, TournamentMatchListItemComponent, TournamentNoMatchesComponent, UserLeagueModule, UserMatchLabelComponent, tournamentClosedMatchesTexts, tournamentListTexts, tournamentMatchListItemTexts, tournamentMatchListTexts, tournamentNoMatchesTexts };
//# sourceMappingURL=play-user-league.js.map
